import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import "../../../Assets/css/holidayGift.css";
import earing from "../../../Assets/images/DFL/holiday-gift/earing.png";
import bracelet from "../../../Assets/images/DFL/holiday-gift/bracelet.png";
import ring from "../../../Assets/images/DFL/holiday-gift/ring.png";
import necklace from "../../../Assets/images/DFL/holiday-gift/necklace.png";
import rings from "../../../Assets/images/DFL/holiday-gift/rings.png";
import pendant from "../../../Assets/images/DFL/holiday-gift/pendant.png";
import hoops from "../../../Assets/images/DFL/holiday-gift/hoops.png";
import diamond from "../../../Assets/images/DFL/holiday-gift/diamond.png";
import cocktailRings from "../../../Assets/images/DFL/holiday-gift/cocktail-ring.png";
import engagement from "../../../Assets/images/DFL/holiday-gift/engagement-ring.png";
import { NavLink, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";


const HolidayGift = () => {
  const history = useHistory();
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <>
         <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails?.description}></meta>
        <meta name="keywords" content={metaDetails?.keywords}></meta>
      </Helmet>
      <div className="dfl_holiday_gift_page_section">
        <Container fluid>
          <Row>
            <div className="dfl_holiday_bg_banner">
              <Col sm={12} md={6} lg={6}>
                <h6>DFL Holiday</h6>
                <h1>Gift Guide</h1>
              </Col>
            </div>
          </Row>
          <Row>
            <div className="dfl_holiday_gift_guide">
              <Col sm={12} md={12} lg={12}>
                <h2 className="dfl_gift_heading">
                  The DFL Holiday Gift Guide 2023
                </h2>
                <p className="dfl_gift_pera pera_width mb-0">
                  The holiday season is a magical time, this year, why not
                  consider something timeless and affordable, starting at ONLY
                  $300 and only your imagination as your limit! Something that
                  sparkles brighter than the festive lights adorning our trees.
                  Yes, we're talking about diamond Jewellery. The joy of
                  unwrapping a diamond gift is a priceless moment that will be
                  cherished for years to come.
                </p>
              </Col>
            </div>
          </Row>
        </Container>
      </div>
      <div className="dfl_gift_ideas_section">
        <Container className="dfl_gift_custom_container">
          <Row>
            <Col sm={12} md={12} lg={12}>
              <h2 className="dfl_gift_heading">
                Our Top 10 Holiday Jewellery Gift Ideas
              </h2>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={5} lg={5}>
              <div className="dfl_gift_idea_img_box">
                <Image src={earing} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/jewellery/diamond-earrings")}/>
              </div>
            </Col>
            <Col sm={12} md={7} lg={7} className="d-flex align-items-center">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Diamond Studs</h2>
                <p className="dfl_gift_pera text-left">
                Simple, elegant, and timeless – <NavLink to="/jewellery/diamond-earrings">diamond studs</NavLink>  are a must-have in every woman's Jewellery box. Their minimalist appeal combined with the dazzling diamonds make them an ideal holiday gift.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={7} lg={7} className="d-flex align-items-center dfl_gift_order1">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Tennis Bracelet</h2>
                <p className="dfl_gift_pera text-left">
                A <NavLink to="/jewellery/diamond-bracelets">tennis bracelet </NavLink>  exudes charm and sophistication. it's a piece
of Jewellery that combines elegance with a modern twist. It's a
gift that she will treasure forever.
                </p>
              </div>
            </Col>
            <Col sm={12} md={5} lg={5} className="dfl_gift_order2">
              <div className="dfl_gift_idea_img_box">
                <Image src={bracelet} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/jewellery/diamond-bracelets")}/>
              </div>
            </Col>
          </Row>
          <Row>
          <Col sm={12} md={5} lg={5}>
              <div className="dfl_gift_idea_img_box">
                <Image src={ring} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/jewellery/wedding-rings/Eternity")}/>
              </div>
            </Col>
            <Col sm={12} md={7} lg={7} className="d-flex align-items-center">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Eternity Ring</h2>
                <p className="dfl_gift_pera text-left">
                Symbolizing never-ending love, an <NavLink to="/jewellery/wedding-rings/Eternity">eternity ring</NavLink>  is a gift that speaks
volumes. Encrusted with diamonds, it's a piece that's as meaningful
as it is beautiful.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
          <Col sm={12} md={7} lg={7} className="d-flex align-items-center dfl_gift_order1">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Diamond Necklace</h2>
                <p className="dfl_gift_pera text-left">
                A <NavLink to="/jewellery/necklaces">diamond necklace </NavLink> is the epitome of elegance and luxury. It’s a
statement piece that can elevate any outfit. A  diamond necklace
is a versatile piece that can be worn on special occasions
or daily.
                </p>
              </div>
            </Col>
          <Col sm={12} md={5} lg={5} className="dfl_gift_order2">
              <div className="dfl_gift_idea_img_box">
                <Image src={necklace} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/jewellery/necklaces")} />
              </div>
            </Col>
            
          </Row>
          <Row>
          <Col sm={12} md={5} lg={5}>
              <div className="dfl_gift_idea_img_box">
                <Image src={rings} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/jewellery/wedding-rings/Stackable")} />
              </div>
            </Col>
            <Col sm={12} md={7} lg={7} className="d-flex align-items-center">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Stackable Rings</h2>
                <p className="dfl_gift_pera text-left">
                For a gift that allows for individual expression, consider <NavLink to="/jewellery/wedding-rings/Stackable">stackable rings</NavLink>.
They're trendy, fun, and offer endless possibilities for
personalization.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
          <Col sm={12} md={7} lg={7} className="d-flex align-items-center dfl_gift_order1">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Diamond Pendant</h2>
                <p className="dfl_gift_pera text-left">
                A <NavLink to="/jewellery/diamond-pendants">diamond pendant</NavLink> is a simple timeless yet captivating piece.
It's a must have and versatile addition to any Jewellery collection.
Available in many shapes and designs to suit all taste and style.
                </p>
              </div>
            </Col>
          <Col sm={12} md={5} lg={5} className="dfl_gift_order2">
              <div className="dfl_gift_idea_img_box">
                <Image src={pendant} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/jewellery/diamond-pendants")} />
              </div>
            </Col>
            
          </Row>
          <Row>
          <Col sm={12} md={5} lg={5}>
              <div className="dfl_gift_idea_img_box">
                <Image src={hoops} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/jewellery/diamond-earrings")} />
              </div>
            </Col>
            <Col sm={12} md={7} lg={7} className="d-flex align-items-center">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Diamond Hoops</h2>
                <p className="dfl_gift_pera text-left">
                For a modern and stylish appeal, <NavLink to="/jewellery/diamond-earrings">diamond hoops</NavLink>  are a perfect choice.
They're fashionable and add a touch of glam to any look. They’re chic,
trendy, and are sure to be a hit this holiday season
                </p>
              </div>
            </Col>
          </Row>
          <Row>
          <Col sm={12} md={7} lg={7} className="d-flex align-items-center dfl_gift_order1">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Diamond Initial</h2>
                <p className="dfl_gift_pera text-left">
                A name <NavLink to="/jewellery/necklaces">necklace</NavLink>  adds a personal touch that is both thoughtful
and stylish. It's a piece that carries a personal sentiment, making
it a special gift.
                </p>
              </div>
            </Col>
          <Col sm={12} md={5} lg={5} className="dfl_gift_order2">
              <div className="dfl_gift_idea_img_box">
                <Image src={diamond} className="img-fluid" alt="Earing Image"   onClick={()=>history.push("/jewellery/necklaces")}/>
              </div>
            </Col>
            
          </Row>
          <Row>
          <Col sm={12} md={5} lg={5}>
              <div className="dfl_gift_idea_img_box">
                <Image src={cocktailRings} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/jewellery/fashion-rings")}/>
              </div>
            </Col>
            <Col sm={12} md={7} lg={7} className="d-flex align-items-center">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Cocktail Ring</h2>
                <p className="dfl_gift_pera text-left">
                A <NavLink to="/jewellery/fashion-rings">cocktail ring</NavLink> is a statement piece that speaks volumes about the
wearer's style. Available in various designs, they're a standout piece
that's perfect for the fashion-forward individual.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
          <Col sm={12} md={12} lg={12} className="d-flex align-items-center justify-content-center">
              <div className="dfl_gift_idea_text_box mt-4 mb-2">
                <h2 className="dfl_gift_subheading text-center dfl_giftcolor_greay_text">Last But Not The Least</h2>
              </div>
            </Col>
          </Row>
          <Row>
          <Col sm={12} md={7} lg={7} className="d-flex align-items-center dfl_gift_order1">
              <div className="dfl_gift_idea_text_box">
                <h2 className="dfl_gift_subheading">Engagement Ring</h2>
                <p className="dfl_gift_pera text-left">
                Last but not least, an <NavLink to="/ringsettings">engagement ring</NavLink> . If you're thinking about taking
your relationship to the next level, the holiday season could be the
perfect time.
                </p>
                <p className="dfl_gift_pera text-left">An engagement ring is more than a gift; it's a promise of a lifetime.
It's a symbol of your love and commitment, and what could be a
better time to express this than the holiday season?</p>
              </div>
            </Col>
          <Col sm={12} md={5} lg={5} className="dfl_gift_order2">
              <div className="dfl_gift_idea_img_box">
                <Image src={engagement} className="img-fluid" alt="Earing Image" onClick={()=>history.push("/ringsettings")}/>
              </div>
            </Col>
            
          </Row>
          
        </Container>
      </div>
      <div>
        <Container>
        <Row>
            <div className="dfl_holiday_gift_guide">
              <Col sm={12} md={12} lg={12}>
                <h2 className="dfl_gift_heading">
                Wrapping Up the Holiday Jewellery Gift Guide
                </h2>
                <p className="dfl_gift_pera pera_width_bottom mb-0">
                Whether it's diamond studs, a tennis bracelet, or an engagement ring, each piece of Jewellery carries
a story and creates memories that last a lifetime. This holiday season, give a gift that will resonate
with their heart and always remind them of your love. After all, diamonds aren't just a girl's best friend;
they are the perfect expression of love. At DIAMONDS FOR LESS our diamond experts will assist you
finding the perfect gift that suits your style, taste and most importantly budget. Happy Holidays!
                </p>
              </Col>
            </div>
          </Row>
        </Container>
      </div>
      <div className="dfl_gift_bottom_text_light_bg_section">
        <Container>
        <Row>
            <div className="dfl_holiday_gift_guide">
              <Col sm={12} md={12} lg={12}>
                {/* <h2 className="dfl_gift_heading">
                Wrapping Up the Holiday Jewellery Gift Guide
                </h2> */}
                <p className="dfl_gift_pera pera_width_bottom_last">
                Join us in celebrating the season of giving with a gift that will be cherished for a lifetime.
Discover the perfect expression of love at Diamonds For Less, Toronto's
#1 name in diamonds since 1985.
                </p>
                <NavLink to="#">Discover Your Perfect Gift Now!</NavLink>
              </Col>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default HolidayGift;
